import React from 'react';
import { Star, Trophy } from 'lucide-react';

export interface TestimonialCardProps {
  name: string;
  title: string;
  avatar: string;
  rating: number;
  content: string;
  achievement?: string;
  personalBest?: string;
  className?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  name,
  title,
  avatar,
  rating,
  content,
  achievement,
  personalBest,
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 ${className}`}>
      <div className="flex items-center mb-6">
        <img
          src={avatar}
          alt={`${name}的头像`}
          className="w-15 h-15 rounded-full mr-4 object-cover"
        />
        <div>
          <h4 className="font-semibold text-gray-900">{name}</h4>
          <p className="text-gray-500 text-sm">{title}</p>
        </div>
      </div>

      <div className="flex items-center mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`w-5 h-5 ${
              i < rating
                ? 'text-yellow-400 fill-current'
                : 'text-gray-300'
            }`}
          />
        ))}
      </div>

      <p className="text-gray-700 leading-relaxed mb-6">
        "{content}"
      </p>

      {(achievement || personalBest) && (
        <div className="border-t border-gray-100 pt-4">
          {achievement && (
            <div className="flex items-center text-orange-500 mb-2">
              <Trophy className="w-4 h-4 mr-2" />
              <span className="font-medium text-sm">{achievement}</span>
            </div>
          )}
          {personalBest && (
            <div className="flex items-center text-blue-500">
              <span className="font-medium text-sm">个人最佳: {personalBest}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TestimonialCard;
